import React from 'react';
import Select from 'react-select';

const NEW_VEHICLE_VALUE = '0';

function toVehicleOptions(vehicles) {
  const list = Array.isArray(vehicles) ? vehicles : [];
  const options = [{ value: NEW_VEHICLE_VALUE, label: 'New Vehicle no' }];

  list.forEach((data) => {
    if (!data || data.id === undefined || data.id === null || data.id === '') {
      return;
    }
    options.push({
      value: String(data.id),
      label: String(data.vehicle_no || ''),
    });
  });

  return options;
}

/**
 * Searchable vehicle-number dropdown for credit sales (single and multi-row forms).
 */
export default function CreditSalesVehicleSelect({
  value,
  vehicles = [],
  onChange,
  disabled = false,
  name = 'vehicle_id',
}) {
  const options = toVehicleOptions(vehicles);
  const stringValue = value === 0 || value === '0' ? NEW_VEHICLE_VALUE : String(value ?? '');
  const selected = options.find((opt) => opt.value === stringValue) || null;

  return (
    <Select
      classNamePrefix="credit-sales-vehicle"
      name={name}
      isSearchable
      isClearable
      isDisabled={disabled}
      placeholder="Search vehicle number"
      options={options}
      value={selected}
      onChange={(option) => onChange(option ? option.value : '')}
      noOptionsMessage={() => 'No vehicle found'}
      menuPortalTarget={typeof document !== 'undefined' ? document.body : null}
      menuPosition="fixed"
      filterOption={(option, input) => {
        if (!input) {
          return true;
        }
        return String(option.label).toLowerCase().includes(String(input).toLowerCase());
      }}
      styles={{
        menuPortal: (base) => ({ ...base, zIndex: 1060 }),
        control: (base) => ({
          ...base,
          minHeight: 38,
          minWidth: 160,
        }),
        menu: (base) => ({ ...base, zIndex: 1060 }),
      }}
    />
  );
}
